import getUserPermissions from "../../../utils/jwt/getUserPermissions";

/**
 * FR-027 (spec 031): solo el propietario/administrador puede comprar, cambiar
 * o cancelar la suscripción. Los demás roles ven consumo y precios con las
 * acciones bloqueadas. Gating actual = claim isAdmin del JWT (idrolespecial).
 */
export const useCanPurchase = (): boolean => {
  try {
    return Boolean(getUserPermissions()?.account?.isAdmin);
  } catch {
    return false;
  }
};

/**
 * Solo un administrador INICIA una prueba gratis de un add-on (2026-09-28;
 * backend: 403 ADDON_TRIAL_ADMIN_ONLY). Mismo claim isAdmin que la compra:
 * `useCanPurchase()` decide si el botón "Probar N días gratis" se habilita.
 */
export const TRIAL_ADMIN_ONLY_HINT = "Pídele a un administrador que active la prueba.";

export const PURCHASE_BLOCKED_HINT =
  "Solo el propietario o un administrador puede realizar compras y cambios de plan.";
